import { ApolloError } from '@apollo/client';
import { CreateRodRequestErrorCode } from '@bechtel/types';

export type CreateRodRequestErrorType = CreateRodRequestErrorCode | ApolloError;

export interface CreateRodRequestErrorProps {
  error: CreateRodRequestErrorType;
  close: () => void;
}
